var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c("h1", [_vm._v(_vm._s(_vm.$t("desktopBetaPage.title")))]),
      _c("p", { staticClass: "intro" }, [
        _vm._v(_vm._s(_vm.$t("desktopBetaPage.intro"))),
      ]),
      _vm.availability === "checking"
        ? _c("p", { staticClass: "status" }, [
            _vm._v(_vm._s(_vm.$t("desktopBetaPage.checking"))),
          ])
        : _vm.availability === "closed"
        ? _c("p", { staticClass: "status" }, [
            _vm._v(_vm._s(_vm.$t("desktopBetaPage.closed"))),
          ])
        : _c(
            "div",
            { staticClass: "actions" },
            [
              _c(
                "button-default",
                {
                  staticClass: "download-button",
                  attrs: { disabled: _vm.downloading !== "" },
                  on: {
                    click: function ($event) {
                      return _vm.download("windows")
                    },
                  },
                },
                [
                  _vm.downloading === "windows"
                    ? _c(
                        "span",
                        { staticClass: "download-button-content" },
                        [
                          _c("icon-spinner", {
                            staticClass: "download-button-spinner",
                          }),
                          _vm._v(
                            " " +
                              _vm._s(_vm.$t("desktopBetaPage.downloading")) +
                              " "
                          ),
                        ],
                        1
                      )
                    : _c("span", [
                        _vm._v(_vm._s(_vm.$t("desktopBetaPage.windowsButton"))),
                      ]),
                ]
              ),
              _c(
                "button-default",
                {
                  staticClass: "download-button",
                  attrs: { disabled: _vm.downloading !== "" },
                  on: {
                    click: function ($event) {
                      return _vm.download("mac")
                    },
                  },
                },
                [
                  _vm.downloading === "mac"
                    ? _c(
                        "span",
                        { staticClass: "download-button-content" },
                        [
                          _c("icon-spinner", {
                            staticClass: "download-button-spinner",
                          }),
                          _vm._v(
                            " " +
                              _vm._s(_vm.$t("desktopBetaPage.downloading")) +
                              " "
                          ),
                        ],
                        1
                      )
                    : _c("span", [
                        _vm._v(_vm._s(_vm.$t("desktopBetaPage.macButton"))),
                      ]),
                ]
              ),
            ],
            1
          ),
      _vm.error
        ? _c("p", { staticClass: "error" }, [_vm._v(_vm._s(_vm.error))])
        : _vm._e(),
      _c(
        "transition",
        { attrs: { name: "windows-install-guide" } },
        [
          _vm.showWindowsInstallGuide
            ? _c("desktop-beta-windows-install-dialog", {
                on: { close: _vm.onCloseWindowsInstallGuide },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }